// Angular modules
import { Component }        from '@angular/core';
import { FormControl }      from '@angular/forms';
import { FormGroup }        from '@angular/forms';
import { FormBuilder }      from '@angular/forms';
import { Validators }       from '@angular/forms';

// Ionic modules
import { NavController }    from 'ionic-angular';
import { ToastController }  from 'ionic-angular';
import { MenuController }   from 'ionic-angular';
import { NavParams }        from 'ionic-angular';
import { GoogleAnalytics }  from '@ionic-native/google-analytics';

// External modules
import { TranslateService } from '@ngx-translate/core';

// Services
import { CartService }      from '../../shared/providers/cart-service';
import { CartItem }         from '../../shared/providers/cart.provider';
import { Cart }             from '../../shared/providers/cart.provider';
import { Calculation } from '../calculator-results/calculation.provider';

// Components

@Component({
  selector    : 'page-add-to-cart',
  templateUrl : 'add-to-cart.html'
})

export class AddToCartPage
{
  formGroup     : FormGroup = null;
  isCalculation : boolean   = false;
  calcName      : string    = '';
  cart          : Cart      = new Cart();
  cartItem      : CartItem  = new CartItem();

  constructor
  (
    public  navCtrl     : NavController,
    public  params      : NavParams,
    public  menuCtrl    : MenuController,
    public  toastCtrl   : ToastController,
    public  cartService : CartService,
    public  t           : TranslateService,
    private builder     : FormBuilder,
    private analytics   : GoogleAnalytics
  )
  {
    this.cartItem.item = params.data;
    this.isCalculation = this.cartItem.item instanceof Calculation;
    this.calcName      = t.instant('CALCULATION');
    this.loadFormGroup();
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Add to cart");
    this.cart = this.cartService.getCart()
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  closeModal()
  {
    this.navCtrl.pop({ animate : false });
  }

  public loadFormGroup() : void
  {
    this.formGroup = this.builder.group({
      groupName : new FormControl({
        value    : null,
        disabled : false
      }, [Validators.required]),
      calcName : new FormControl({
        value    : null,
        disabled : false
      })
    });

    if(this.isCalculation)
      this.formGroup.controls.calcName.setValidators(Validators.required);
  }

  addToCart()
  {
    let groupName : string = null;
    let calcName  : string = null;
    groupName = this.formGroup.controls.groupName.value;
    calcName  = this.formGroup.controls.calcName.value;

    this.cartItem.group = groupName;

    if (this.isCalculation)
    {
      (<Calculation>this.cartItem.item).name = calcName;
    }
    this.cartService.addItem(this.cartItem);
    this.presentToast(this.t.instant('ADDED_TO_CART'));
    this.closeModal();
  }

  presentToast(message)
  {
    let toast = this.toastCtrl.create({
      message  : message,
      duration : 3000
    });
    toast.present();
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/add-to-cart/add-to-cart.ts